// @flow
import React from "react";
import * as PropType from "prop-types";
import LIButton from "./LIButton";

const AuthButton = ({user, signOutClicked, nameBelow}) => {

    function showName() {
        if(nameBelow) {
            return <div className="li-font-small mr-0" 
                        style={{width:"10em", textOverflow:"ellipsis", overflow:"hidden", whiteSpace:"nowrap"}}>
                        {user??"unknown person"}</div>;
        }
        return <span className="li-font-small mr-2"
                     style={{width:"8em", textOverflow:"ellipsis", overflow:"hidden", whiteSpace:"nowrap"}}>
                        {user??"unknown person"}</span>;
    }
    
    return (
        <span className="">
            {!nameBelow && showName()}
            <LIButton primary bgClass="li-header-button" onClick={signOutClicked} tooltip="sign out" faIcon="fas fa-sign-out-alt"/>
            {nameBelow && showName()}
        </span>
    );
}

AuthButton.propTypes = {
    user: PropType.string,
    signOutClicked: PropType.func,
    nameBelow: PropType.bool
}

export default AuthButton;